export default __webpack_public_path__ + "static/media/awar2.324832a7.jpg";